export default {
  submitted: {
    pt: 'Seu envio para esse concurso está confirmado com sucesso',
    en: 'Your submission to this contest is successfully confirmed'
  },
  results_when: {
    pt: 'Resultados em:',
    en: 'Results date:'
  },
  you_can_send_up_to: {
    pt: 'Você pode enviar até mais',
    en: 'You can send up to'
  },
  more_entries_for_free: {
    pt: 'entrada(s) gratuitamente e mais',
    en: 'more entries for free and more'
  },
  extra_entries: {
    pt: 'extradas extras',
    en: 'extras entries'
  },
  submmited_send_more_free: {
    pt: 'Sua participação neste concurso já está confirmada, mas você ainda pode enviar até mais',
    en: 'Your participation in this contest has already been confirmed, but you can still submit up to'
  },
  entries_for: {
    pt: 'entrada(s) por R$',
    en: 'more entries for U$'
  },
  each: {
    pt: 'cada',
    en: 'each'
  },
  maximum_reached: {
    pt: 'Você chegou ao máximo de entradas permitidas',
    en: 'You have reached the maximum number of entries allowed'
  },
  maximum_reached_submitted: {
    pt: 'Sua participação neste concurso já foi realizada e seu envio contém o máximo de entradas permitidas.',
    en: 'Your participation in this contest has already been performed and your submission contains the maximum number of entries allowed.'
  },
  add_free_album: {
    pt: 'Adicionar álbum free',
    en: 'Add free album'
  },
  add_extra_album: {
    pt: 'Adicionar álbum extra',
    en: 'Add extra album'
  },
  pending_payment: {
    pt: 'O pagamento para este concurso ainda não foi confirmado. Caso já o realizou, em breve será confirmado.',
    en: 'The payment for this contest has not yet been confirmed. If you have already done, it will soon be confirmed.'
  },
  try_payment_again: {
    pt: 'Se ainda não o fez, faça o pagamento aqui.',
    en: 'In case you haven\'t, please make payment here'
  },
  view_bank_slip: {
    pt: 'Visualizar boleto',
    en: 'View bank slip'
  },
  expired_boleto: {
    pt: 'O boleto gerado anteriormente venceu, mas você pode realizar outro pagamento aqui.',
    en: 'The previously generated payment has expired, but you can make another payment here.'
  },
  success_dialog_title: {
    pt: 'Sua participação está confirmada!',
    en: 'Your participation is confirmed!'
  },
  success_dialog_text: {
    pt: 'Seu envio foi realizado com sucesso e você está participando neste concurso. Fique atento para as novidades a respeito do Awards!',
    en: 'Your submission has been successful and you are participating in this contest. Stay tuned for the news about the Awards!'
  },
  try_again: {
    pt: 'Tentar novamente',
    en: 'Try again'
  },
  close: {
    pt: 'Fechar',
    en: 'Close'
  },
  confirm_submission: {
    pt: 'Confirmar envio',
    en: 'Confirm submission'
  },
  rules_agreement: {
    pt: 'Ao finalizar, você atesta que leu e compreendeu o regulamento, aceita as regras e concorda com elas, declara também que seu envio está de acordo.',
    en: 'By submitting you state that you have read and understood the rules, accept and agree to them, and also state that your submission respects it.'
  },
  admit_judges_comments: {
    pt: 'Nos concursos, os juízes têm a possibilidade de comentar nas entradas para dar elogios, ideias, críticas construtivas e demais pensamentos. Fica ao critério de cada juiz escolher quais participações deseja comentar.',
    en: 'In contests, the judges have the possibility to comment on the entries to give praise, ideas, constructive criticism and other thoughts. It is up to each judge to choose which entries he wishes to comment on.'
  },
  admit_judges_comments_allow: {
    pt: 'Permito que juízes comentem em minha participação.',
    en: 'I allow judges to comment in my participation.'
  },
  admit_judges_comments_accept_note: {
    pt: 'Observação: Cabe a cada juiz escolher quais fotos irá ou não comentar. Ao marcar que aceita receber comentários não significa que necessariamente os receberá.',
    en: 'Note: It is up to each judge to choose which photos will or will not comment. By checking that you accept receiving comments does not mean that you will necessarily receive them.'
  },
  admit_judges_comments_refuse: {
    pt: 'Não desejo que juízes comentem em minha participação.',
    en: 'I\'d like to judges to NOT comment in my participation.'
  },
  pay_and_submit: {
    pt: 'Pagar e enviar',
    en: 'Pay and submit'
  },
  read_the_rules: {
    pt: 'Ler regulamento completo',
    en: 'Read the all the rules'
  },
  submit: {
    pt: 'Enviar',
    en: 'Submit'
  },
  error_dialog_title: {
    pt: 'Houve um problema com seu envio',
    en: 'There was a problem with your submission'
  },
  error_dialog_text: {
    pt: 'Em virtude de um problema de conexão, não foi possível completar o seu envio. Mas não há problemas, apenas tente novamente! Caso o problema persista, entre em contato conosco em contato@inspirationphotographers.com',
    en: 'Due to a connection problem, your submission could not be completed. But no problems, just try again! If the problem persists, contact us at contato@inspirationphotographers.com'
  },
  submitting: {
    pt: 'Enviando',
    en: 'Submitting'
  },
  processing_submission: {
    pt: 'Processando envio',
    en: 'Processing submission'
  },
  processing_image: {
    pt: 'Processando imagem',
    en: 'Processing image'
  },
  processing_image_of: {
    pt: 'de',
    en: 'of'
  },
  pictures: {
    pt: 'fotos',
    en: 'photos'
  },
  limit_reached: {
    pt: 'Você enviou o total de imagens para o álbum',
    en: 'You have uploaded the total images to the album'
  },
  submit_pictures: {
    pt: 'Enviar fotos',
    en: 'Submit pictures'
  },
  photos_alert: {
    pt: 'Imagens devem ser .jpg e nas dimensões 1200x800 pixels.',
    en: 'Images must be .jpg and 1200x800 pixels.'
  },
  tutorial_link: {
    pt: 'Dúvidas sobre como redimensionar? Assista o tutorial aqui.',
    en: 'Need help to resize the pictures? Watch the guide here.'
  },
  remove_photo: {
    pt: 'Remover foto',
    en: 'Remove photo'
  },
  file: {
    pt: 'Arquivo',
    en: 'File'
  },
  requirements: {
    pt: 'fora dos requerimentos',
    en: 'does not meet the requirements'
  },
  submit_limit: {
    pt: 'Limite de envio de imagens é de',
    en: 'Image upload limit is'
  },
  files: {
    pt: 'arquivos',
    en: 'files'
  },
  rules_required: {
    pt: 'Campo obrigatório.',
    en: 'Required field.'
  },
  error_alert: {
    pt: 'Houve um problema com o seu envio de fotos:',
    en: 'There is an error with your media submit:'
  },
  limit_available: {
    pt: 'Você pode enviar mais',
    en: 'You can send up to more'
  },
  submiting: {
    pt: 'Enviando',
    en: 'Submitting'
  }
}
